import axios from 'axios';

export default class Print {
  constructor(axiosConfig, applicationURL) {
    this.axiosConfig = axiosConfig;
    this.applicationURL = applicationURL;
  }

  async printToPDF(type, name) {
    const axiosSvc = axios.create(this.axiosConfig);
    let response = await axiosSvc.post('/pdf/', {
      url: this.applicationURL + '#/?' + type + '=' + name
    });
    if (
      response &&
      response.status >= 200 &&
      (response.status < 300 || response.status === 304)
    ) {
      return response.data;
    } else {
      throw Error(
        `Error getting item '${name}': ${response.status} - ${response.statusText}`
      );
    }
  }
}
